import { render, staticRenderFns } from "./NewCarorderForm.vue?vue&type=template&id=38e3163c&"
import script from "./NewCarorderForm.vue?vue&type=script&lang=ts&"
export * from "./NewCarorderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports